var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBit2MeLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 93 30",
    style: {
      enableBackground: "new 0 0 93 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000160184911388859941410000003721237942714444977_);}\n\t.st1{fill:#0046E1;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.6,
    y: 0.6,
    width: 91.8,
    height: 28.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115491969795363068340000013754916181389969812_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000115491969795363068340000013754916181389969812_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.7,11.9c-1.3,0-2.3,0.6-3,1.5V8H0.6v14.8h3.2v-1.4c0.7,1,1.8,1.6,3,1.6c2.8,0,4.6-2.2,4.6-5.4 C11.4,14.1,9.5,11.9,6.7,11.9z M6,20.2c-1.3,0-2.2-1.1-2.2-2.8c0-1.6,0.9-2.8,2.2-2.8c1.3,0,2.2,1.2,2.2,2.8 C8.2,19,7.3,20.2,6,20.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.7,7.1c-1,0-1.7,0.8-1.7,1.8c0,1.1,0.7,1.8,1.7,1.8c1,0,1.7-0.8,1.7-1.8C16.4,7.9,15.7,7.1,14.7,7.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.1,22.8h3.2V12h-3.2V22.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.6,19.8c-0.5,0.2-0.9,0.4-1.2,0.4c-0.6,0-0.9-0.3-0.9-1.2v-4.2H25v-2.3h-2.6v-3h-3.2v3h-1.4v2.3h1.4v4.7 c0,2.2,1.4,3.4,3.3,3.4c1,0,1.9-0.3,2.6-0.7L24.6,19.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.8,11.4c-1.7,0-2.9,0.9-3.6,2.5c-0.5-1.6-1.7-2.5-3.4-2.5c-1.5,0-2.7,0.7-3.4,2v-1.8h-3.3v11.2h3.3v-5.5 c0-1.5,0.8-2.6,2-2.6c1.1,0,1.7,0.8,1.7,2.1v6h3.3v-5.5c0-1.5,0.8-2.6,2-2.6c1.1,0,1.8,0.8,1.8,2.1v6h3.3v-7 C80.4,13.1,79,11.4,76.8,11.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.2,11.4c-3.2,0-5.3,2.3-5.3,5.7c0,3.4,2.1,5.7,5.4,5.7c1.9,0,3.4-0.7,4.4-2L90,19 c-0.7,0.7-1.6,1.1-2.4,1.1c-1.2,0-2.1-0.7-2.4-2.1h7.2C92.6,14,90.8,11.4,87.2,11.4z M89.2,16.2h-4.1c0.2-1.3,1-2.3,2.1-2.3 C88.4,13.9,89.2,14.8,89.2,16.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.7,1.3c-2.1-0.7-4.4-0.9-6.6-0.5c-2.2,0.3-4.3,1.2-6.1,2.4c-0.2-0.2-0.4-0.3-0.7-0.3 c-0.3-0.1-0.7-0.1-1-0.1c-0.3,0-0.7,0.1-1,0.3s-0.6,0.4-0.8,0.6c-0.2,0.3-0.4,0.6-0.5,0.9c-0.1,0.4-0.2,0.8-0.1,1.2 c0.1,0.4,0.2,0.8,0.5,1.1c-1.2,1.8-2,3.9-2.4,6c-0.3,2.2-0.1,4.4,0.5,6.5c0.7,2.1,1.8,4,3.3,5.6c1.5,1.6,3.4,2.8,5.4,3.6 c0.2,0.1,0.3,0.1,0.5,0.2c1.8,0.6,3.7,0.8,5.6,0.7c1.9-0.1,3.7-0.7,5.4-1.5c0.6-0.3,1.1-0.6,1.6-1l1.3,1.3 c0.1,0.1,0.3,0.1,0.3-0.1l1.4-4c1.1-1.4,2-3,2.6-4.7C60.4,11.9,56.3,3.8,48.7,1.3z M56.8,19.1c-0.5,1.4-1.2,2.7-2.1,3.9l-4.3,1.5 c-0.2,0.1-0.2,0.2-0.1,0.3l1.2,1.2c-0.4,0.3-0.8,0.5-1.3,0.7c-1.5,0.8-3.2,1.3-4.9,1.4c-1.7,0.1-3.4-0.1-5.1-0.6 c-7-2.3-10.7-9.7-8.4-16.6c0.4-1.1,0.9-2.2,1.6-3.2c0.1,0.1,0.2,0.1,0.4,0.2c0.3,0.1,0.7,0.1,1,0.1c0.3,0,0.7-0.1,1-0.3 C36,7.5,36.3,7.3,36.5,7c0.2-0.3,0.4-0.6,0.5-0.9c0.1-0.3,0.1-0.7,0.1-1c0-0.3-0.1-0.7-0.3-1C38.5,3,40.4,2.3,42.4,2 c2-0.3,4-0.1,5.9,0.5c0.2,0.1,0.3,0.1,0.5,0.2c3.2,1.2,5.8,3.5,7.3,6.6C57.6,12.3,57.8,15.8,56.8,19.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,16.7c1-1,1.7-1.9,2-2.5c0.4-0.6,0.6-1.3,0.6-2.1c0-1.3-0.5-2.4-1.4-3.1c-0.9-0.8-2-1.1-3.2-1.1 c-1.2,0-2.2,0.3-3,0.8c-0.8,0.5-1.5,1.3-2.1,2.3l2.5,1.5c0.8-1.3,1.6-1.9,2.5-1.9c0.5,0,0.9,0.2,1.2,0.5c0.2,0.2,0.3,0.3,0.3,0.5 c0.1,0.2,0.1,0.4,0.1,0.6c0,0.5-0.2,0.9-0.5,1.4c-0.4,0.5-0.9,1.2-1.8,2l-4.1,4.2v2.3h9.8v-2.8h-5.5L46.3,16.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBit2MeLogoLight);
export default __webpack_public_path__ + "static/media/bit2me-logo-light.14f53ea95df752b82cb73d5d52b61b27.svg";
export { ForwardRef as ReactComponent };